import React, { useEffect, useRef, useState } from "react";
import SelectFromLibr from "./SelectFromLibr";
import DefaultQuestion from "./DefaultQuestion";
import QuestionListAssessment from "./QuestionListAssessment";
import axios from "../../axios";
import { useSelector } from "react-redux";
import ProgressBar from "../../Helper/ProgressBar";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
import OperationType from "../../Enum/OperationTypeEnum";
import ComponentType from "../../Enum/ComponentTypeEnum";
import { useNavigate } from "react-router-dom";
import PublishPreviewQB from "./PublishPreviewQB";
import FailedApiErrorPopup from "./FailedApiErrorPopup";
import AiGenerateQuestions from "./AiGenerateQuestions";
import CheckDuplicatePop from "./CheckDuplicatePop";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Tooltip,
  Typography,
} from "@mui/material";
import RightDrawer from "./rightDrawer";
import QuestionPaperMapper from "./QuestionPaperMaper";
import { LibraryButton } from "./UpdateQustion";
import { hasDescriptiveAutoAssessment, hasFeature } from "../../Utils/features";

const CreateQuestion = ({
  componentType,
  setClickFromCreate,
  assessmentDetails,
  setAssessmentDetails,
  setUnsavedChanges,
  redirectStateData,
  selectedBox,
}) => {
  const [questionTypeData, setQuestionTypeData] = useState([]);
  const [difficultyLevel, setDifficultyLevel] = useState([]);
  const [sourceLibrary, setSourceLibrary] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [hidePopupCheck, setHidePopupCheck] = useState(false);
  const [viewErrorMsg, setViewErrorMsg] = useState("");
  const [apiViewErrorMsg, setApiViewErrorMsg] = useState("");
  const [questionData, setquestionData] = useState([]);
  const [openQuestionBox, setOpenQuestionBox] = useState(false);
  const [isopenPopupDupli, isSetOpenPopupDupli] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);

  // 🔹 Feature flag
  const hasDescriptiveAutoAssessmentFlag = hasDescriptiveAutoAssessment;

  // ⭐ AUTO-EVAL MODE — single source of truth
  const isAutoEvalMode =
    selectedBox === "auto-evaluate" ||
    selectedBox?.autoEvaluate === true ||
    selectedBox?.isAutoEvaluate === true;

  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
  } = assessmentDetails;
  const school_id = JSON.parse(localStorage.getItem("schoolId"));
  const [click, setClick] = useState(false);
  const [click1, setClick1] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const domainsData = useSelector((state) => state.initialData.domain);
  const skillsData = useSelector((state) => state.initialData.skills);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const [newQuestionPaperMaper, setNewQuestionPaperMaper] = useState(false);
  const [copyPrevSettings, setCopyPrevSettings] = useState(true);
  const [showProcessingDialog, setShowProcessingDialog] = useState(false);
  const [showErrorInputField, setShowErrorInputField] = useState(false);
  const [getErrorMsg, setGetErrorMsg] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [questionType, setQuestionType] = useState([]);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [questionScoreCounter, setQuestionScoreCounter] = useState({
    skills: [],
    questionType: [],
    difficultyLevel: [],
  });

  const [searchTerm, setSearchTerm] = useState("");
  const questionRefs = useRef({});
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  const checkQuestionTypes = async () => {
    try {
      const res = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`,
      );

      if (res.data.data.length > 0) setQuestionType(res.data.data);
    } catch (error) {
      console.log(error, "error while fetching quwstion type");
    }
  };

  useEffect(() => {
    checkQuestionTypes();
  }, [school_id]);

  const [dropdownList, setDropdownList] = useState({
    skills: skillsData,
    types: questionType,
    domains: null,
    chapters: null,
    difficultyLevels: difficulty_levelData,
  });
  const { skills, domains, chapters, difficultyLevels } = dropdownList;
  const { types } = dropdownList;

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`,
      );
      chapters &&
        setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDropdownList((prev) => ({ ...prev, skills: skillsData }));
    setDropdownList((prev) => ({ ...prev, types: questionType }));
    setDropdownList((prev) => ({ ...prev, domains: domainsData }));
    setDropdownList((prev) => ({
      ...prev,
      difficultyLevels: difficulty_levelData,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skills, types, domains, difficultyLevels, questionType]);

  const [questions, setQuestions] = useState([]);
  const saveTimer = useRef(null);

  console.log(questions, "questions");

  useEffect(() => {
    if (!questions || questions.length === 0) return;

    if (saveTimer.current) clearTimeout(saveTimer.current);

    saveTimer.current = setTimeout(() => {
      const key = `temp_Questions_${componentType}`;

      if (componentType === ComponentType.ASSESSMENT) {
        localStorage.setItem("currentStep", 3);
        localStorage.setItem(
          key,
          JSON.stringify({ assessmentDetails, questions }),
        );
      }
      if (componentType === ComponentType.HOMEWORK) {
        localStorage.setItem("currentStepHW", 3);
        localStorage.setItem(
          key,
          JSON.stringify({ HomeWorkDetails: assessmentDetails, questions }),
        );
      }
      if (componentType === ComponentType.QUESTION_BANK) {
        localStorage.setItem(
          key,
          JSON.stringify({ questionBankData: assessmentDetails, questions }),
        );
      }
    }, 3000);

    return () => {
      if (saveTimer.current) clearTimeout(saveTimer.current);
    };
  }, [questions, assessmentDetails, componentType]);

  useEffect(() => {
    const key = `temp_Questions_${componentType}`;
    const savedTempLocal = JSON.parse(localStorage.getItem(key));

    if (!savedTempLocal) return;

    if (componentType) {
      if (componentType === ComponentType.HOMEWORK) {
        setAssessmentDetails(savedTempLocal.HomeWorkDetails);
        setQuestions(savedTempLocal.questions);
      }
      if (componentType === ComponentType.ASSESSMENT) {
        setAssessmentDetails(savedTempLocal.assessmentDetails);
        setQuestions(savedTempLocal.questions);
      }
      if (componentType === ComponentType.QUESTION_BANK) {
        setAssessmentDetails(savedTempLocal.questionBankData);
        setQuestions(savedTempLocal.questions);
      }
    }
  }, [componentType]);

  const getBaseQuestionTemplate = () => {
    const isAdaptiveSelected =
      selectedBox === "adaptive" ||
      selectedBox === "auto-evaluate" ||
      selectedBox?.adaptive ||
      selectedBox?.isAdaptive ||
      selectedBox?.autoEvaluate;

    const mcqType = types?.find((t) => t.type === "multiple choice");

    return {
      standard_id: standard_id ? standard_id.id : null,
      subject_id: subject_id ? subject_id.id : null,
      section_id: section_id ? section_id.id : null,

      book_id: null,
      chapter_id: null,
      domain_id: null,
      skill_id: null,
      difficulty_level: null,

      question_type: isAdaptiveSelected ? "false" : "null",
      type_id: isAdaptiveSelected && mcqType ? mcqType.id : null,

      title: null,
      correct_score: 0,
      is_question_edited: false,

      is_mandatory: false,
      add_to: "all",
      add_to_mock: false,

      attachments: [],

      options: [
        { key: "A", value: null },
        { key: "B", value: null },
        { key: "C", value: null },
        { key: "D", value: null },
      ],

      correct_answers: [
        {
          option_key: null,
          value: null,
          reason_for_answer: {
            attachment: null,
            explanation: null,
          },
        },
      ],
    };
  };

  const addMoreQuestion = () => {
    setQuestions((prev) => {
      const baseQuestion = getBaseQuestionTemplate();

      if (copyPrevSettings && prev.length > 0) {
        const previous = prev[prev.length - 1];

        const copiedTypeId = previous.type_id ?? baseQuestion.type_id;
        const copiedQuestionType =
          previous.question_type ?? baseQuestion.question_type;

        const copiedIsManuallyGraded = copiedQuestionType === "true";

        let newQuestion = {
          ...baseQuestion,

          book_id: previous.book_id,
          chapter_id: previous.chapter_id,
          skill_id: previous.skill_id,
          domain_id: previous.domain_id,
          difficulty_level: previous.difficulty_level,
          type_id: copiedTypeId,
          question_type: copiedQuestionType,
          correct_score: previous.correct_score,
          add_to: "all",
          add_to_mock: false,
        };

        if (
          hasDescriptiveAutoAssessmentFlag &&
          isAutoEvalMode &&
          copiedIsManuallyGraded &&
          previous.subjective_evaluation
        ) {
          const hasRealContent =
            (previous.subjective_evaluation.expectedAnswer &&
              previous.subjective_evaluation.expectedAnswer.trim()) ||
            (Array.isArray(previous.subjective_evaluation.rubric) &&
              previous.subjective_evaluation.rubric.length > 0);

          newQuestion.subjective_evaluation = {
            enabled: hasRealContent
              ? (previous.subjective_evaluation.enabled ?? false)
              : false,
            expectedAnswer: previous.subjective_evaluation.expectedAnswer || "",
            rubric: Array.isArray(previous.subjective_evaluation.rubric)
              ? previous.subjective_evaluation.rubric.map((r) => ({ ...r }))
              : [],
          };
        } else if (
          hasDescriptiveAutoAssessmentFlag &&
          isAutoEvalMode &&
          copiedIsManuallyGraded &&
          !previous.subjective_evaluation
        ) {
          newQuestion.subjective_evaluation = {
            enabled: false,
            expectedAnswer: "",
            rubric: [],
          };
        }

        return [...prev, newQuestion];
      }

      return [...prev, baseQuestion];
    });
  };

  const checkAllDataField = () => {
    let hasError = false;

    const isQuestionLibraryComponent =
      componentType === ComponentType.QUESTION_BANK;

    questions.forEach((question, index) => {
      if (!question.title) {
        setGetErrorMsg(`Title missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.skill_id) {
        setGetErrorMsg(`Skill missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.type_id) {
        setGetErrorMsg(`Question Type missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.chapter_id) {
        setGetErrorMsg(`Book & Chapter missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.correct_score) {
        setGetErrorMsg(`Correct Score missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.difficulty_level) {
        setGetErrorMsg(`Difficulty Level missing in question ${index + 1}`);
        hasError = true;
      }

      if (isQuestionLibraryComponent) {
        const isAddToMissing =
          !question?.add_to || question.add_to.trim() === "";
        const isMockMissing =
          question?.add_to_mock === undefined ||
          question?.add_to_mock === false;

        if (isAddToMissing && isMockMissing) {
          setGetErrorMsg(`Add to missing in question ${index + 1}`);
          hasError = true;
        }
      }

      const skipOptionValidation = isQuestionLibraryComponent
        ? question.question_type === "true"
        : hasDescriptiveAutoAssessmentFlag &&
          isAutoEvalMode &&
          question.question_type === "true";

      if (question.type_id && !skipOptionValidation) {
        if (Array.isArray(question.options) && question.options.length > 0) {
          question.options.forEach((opt) => {
            if (!opt?.key || opt.key.trim() === "") {
              setGetErrorMsg(`Option key missing in question ${index + 1}`);
              hasError = true;
            }
            if (!opt?.value || opt.value.trim() === "") {
              setGetErrorMsg(`Option value missing in question ${index + 1}`);
              hasError = true;
            }
          });
        }
      }

      if (question.type_id && !skipOptionValidation) {
        if (Array.isArray(question.correct_answers)) {
          question?.correct_answers?.forEach((ans) => {
            if (question?.options?.length > 0) {
              if (!ans?.option_key || ans.option_key.trim() === "") {
                setGetErrorMsg(`Option key missing in question ${index + 1}`);
                hasError = true;
              }
            }
          });
        }
      }
    });

    if (hasError) {
      setShowErrorInputField(true);
      return true;
    }

    return false;
  };

  const findDuplicateQuestions = () => {
    const seen = new Set();
    const duplicates = [];

    questions.forEach((question, index) => {
      const id = question.id || question.b4sQuestion;
      if (question.is_question_edited || !id) return;

      if (seen.has(id)) {
        duplicates.push(index + 1);
      } else {
        seen.add(id);
      }
    });

    if (duplicates.length > 0) {
      setViewErrorMsg(`Duplicate question found at Q${duplicates.join(", Q")}`);
      isSetOpenPopupDupli(true);
      return true;
    }

    return false;
  };

  const handleAdaptiveQuesType = () => {
    let nonAdaptiveQustionType = [];
    let hasNonAdaptive = false;

    questions.forEach((question, index) => {
      if (selectedBox === "adaptive" && selectedBox === "auto-evaluate") {
        const isCheckNonMCQ = question?.options?.length === 0;
        if (isCheckNonMCQ) {
          hasNonAdaptive = true;
          nonAdaptiveQustionType.push(index + 1);
        }
      }
      setHidePopupCheck(hasNonAdaptive);
    });

    if (hasNonAdaptive) {
      setOpenPopup(true);
      setViewErrorMsg(
        `Non-MCQ questions are found in Adaptive Assessment. \nPlease check the questions Q${nonAdaptiveQustionType.join(
          ", Q",
        )}`,
      );
    } else {
      setOpenPopup(false);
    }
  };

  // ⭐ Payload cleaner
  const buildCleanedQuestions = (rawQuestions) => {
    return (rawQuestions || []).map((val) => {
      const q = { ...val };

      if (q.is_question_edited || q.id !== undefined) {
        delete q.id;
      }

      const isManuallyGraded = q.question_type === "true";
      const isQuestionBank = componentType === ComponentType.QUESTION_BANK;

      if (isQuestionBank) {
        if (isManuallyGraded) {
          q.subjective_evaluation = {
            enabled: false,
            expectedAnswer: "",
            rubric: [],
          };
        } else {
          delete q.subjective_evaluation;
        }
        return q;
      }

      if (!hasDescriptiveAutoAssessmentFlag || !isAutoEvalMode) {
        delete q.subjective_evaluation;
        return q;
      }

      if (!isManuallyGraded) {
        delete q.subjective_evaluation;
        return q;
      }

      const se = q.subjective_evaluation;

      const hasContent =
        (se?.expectedAnswer && se.expectedAnswer.trim()) ||
        (Array.isArray(se?.rubric) && se.rubric.length > 0);

      if (!hasContent) {
        delete q.subjective_evaluation;
        return q;
      }

      const isAiEnabled = se?.enabled ?? false;

      let finalRubric = [];
      if (isAiEnabled) {
        finalRubric = (se.rubric || []).filter(
          (r) => (r.criterion && r.criterion.trim()) || Number(r.maxMarks) > 0,
        );
      }

      q.subjective_evaluation = {
        enabled: isAiEnabled,
        expectedAnswer: se.expectedAnswer || "",
        rubric: finalRubric,
      };

      return q;
    });
  };

  const findTotalMarks = () => {
    return (
      questions &&
      questions?.reduce((acc, curr) => acc + Number(curr.correct_score), 0)
    );
  };

  const maxMarks = Number(assessmentDetails?.maxMarks) || 0;
  const totalMarks = findTotalMarks() || 0;
  const marksDiff = totalMarks - maxMarks;

  const isMarksMismatch = maxMarks > 0 && totalMarks !== maxMarks;

  const marksStatus =
    totalMarks === maxMarks && maxMarks > 0
      ? "match"
      : totalMarks > maxMarks
        ? "exceeded"
        : "short";

  const handleCreateAssessment = async () => {
    if (maxMarks > 0 && totalMarks !== maxMarks) {
      setOpen(false);
      toast.error(
        marksStatus === "exceeded"
          ? `Total marks exceeded by ${marksDiff}. Please reduce ${marksDiff} mark(s).`
          : `${Math.abs(marksDiff)} mark(s) remaining. Please add more questions or increase marks.`,
      );
      return;
    }

    const cleanedQuestions = buildCleanedQuestions(questions);
    const isHeavyAssessment = cleanedQuestions.length > 20;

    if (isHeavyAssessment) {
      setShowProcessingDialog(true);
    } else {
      setIsInProgress(true);
    }

    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id:
        componentType === ComponentType.ASSESSMENT
          ? null
          : assessmentDetails.type_id,
      assessmentTypeId: assessmentDetails.assessmentTypeId,
      assessmentEventId: assessmentDetails.assessmentEventId,
      ...(componentType === ComponentType.HOMEWORK
        ? {
            academic_session_id: academicSessionId,
            timetable_session_id: timeTableSessionId,
          }
        : {
            academicSessionId: academicSessionId,
            timetableSessionId: timeTableSessionId,
          }),
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "draft",
      isAdaptive: selectedBox === "adaptive" ? true : false,
      autoEvalEnabled: isAutoEvalMode ? true : false,
      total_duration: assessmentDetails.total_duration,
      questions: cleanedQuestions,
    };

    try {
      if (componentType === ComponentType.ASSESSMENT) {
        let res = await axios.post(`/api/v1/assessment/create`, newAssessment);
        if (res) {
          if (redirectStateData !== null) {
            navigate("/liveSession", { state: redirectStateData });
          } else {
            navigate("/publishedAssessment", { selectedBox: selectedBox });
          }
          localStorage.setItem("isCheckAdaptive", res?.data?.data?.isAdaptive);
        }
      } else if (componentType === ComponentType.HOMEWORK) {
        let res = await axios.post(`/api/v1/homework/create`, newAssessment);
        if (res) {
          if (redirectStateData !== null) {
            navigate("/liveSession", { state: redirectStateData });
          } else {
            navigate("/PublishedHomework");
          }
        }
      }
    } catch (error) {
      setIsInProgress(false);
      console.log("error", error);
    } finally {
      if (componentType === ComponentType.ASSESSMENT) {
        localStorage.removeItem("temp_Questions_ASSESSMENT");
        localStorage.removeItem("currentStep");
        localStorage.removeItem("assessmentDetails");
        localStorage.removeItem("selectedBox");
      }
      if (componentType === ComponentType.HOMEWORK) {
        localStorage.removeItem("temp_Questions_HOMEWORK");
        localStorage.removeItem("currentStepHW");
        localStorage.removeItem("HomeWorkDetails");
      }
      if (componentType === ComponentType.QUESTION_BANK) {
        localStorage.removeItem("temp_Questions_QUESTION_BANK");
      }
      setShowProcessingDialog(false);
      setIsInProgress(false);
    }
  };

  useEffect(() => {
    setInitialDataInCounter();
    questions &&
      questions.map((item, index) => {
        const correctScore = Number(item.correct_score);
        if (item.skill_id !== null) {
          setQuestionScoreCounter((prev) => {
            let current = prev.skills.map((val, i) => {
              if (val.id == item.skill_id) {
                val["value"] += correctScore;
              }
              return val;
            });
            return { ...prev, skills: current };
          });
        }
        if (item.question_type !== null) {
          setQuestionScoreCounter((prev) => {
            let current = prev.questionType.map((val, i) => {
              if (val.id == item.type_id) {
                val["value"] += correctScore;
              }
              return val;
            });
            return { ...prev, questionType: current };
          });
        }
        if (item.difficulty_level !== null) {
          setQuestionScoreCounter((prev) => {
            let current = prev.difficultyLevel.map((val, i) => {
              if (val.id == item.difficulty_level) {
                val["value"] += correctScore;
              }
              return val;
            });
            return { ...prev, difficultyLevel: current };
          });
        }
      });
  }, [questions]);

  const setInitialDataInCounter = () => {
    let skills = [];
    skillsData.map((skill) => {
      skills.push({ value: 0, label: skill.name, id: skill.id });
    });
    setQuestionScoreCounter((prev) => ({ ...prev, skills: skills }));

    let qType = [];
    questionType.map((type) => {
      qType.push({ value: 0, label: type.name, id: type.id });
    });
    setQuestionScoreCounter((prev) => ({ ...prev, questionType: qType }));
    setQuestionTypeData(qType);

    let dLevel = [];
    difficulty_levelData.map((level, i) => {
      dLevel.push({ value: 0, label: level.name, id: level.id });
    });
    setQuestionScoreCounter((prev) => ({ ...prev, difficultyLevel: dLevel }));
    setDifficultyLevel(dLevel);
  };

  useEffect(() => {
    setInitialDataInCounter();
  }, []);

  const getquestiondata = (data) => {
    setquestionData(data);
  };

  function shortenParagraph(text, maxLength) {
    if (text?.length <= maxLength) {
      return text;
    }
    return text && text.slice(0, maxLength).trim() + "...";
  }

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const QuestionBankComponentHeight = "calc(100vh - 200px)";
  const homeWorkComponentHeight = "calc(100vh - 270px)";

  const skillToDomainNameMap = {
    Remember: "Factual",
    Understand: "Conceptual",
    Apply: "Conceptual",
    Analyze: "Procedural",
    Evaluate: "Metacognitive",
    Create: "Metacognitive",
    None: "None",
  };

  const domainNameToIdMap = Object.fromEntries(
    Array.isArray(domains) ? domains.map((d) => [d.name, d.id]) : [],
  );

  const skillsWithDomainId =
    Array.isArray(skills) &&
    skills.map((skill) => {
      const domainName = skillToDomainNameMap[skill.name];
      const domainId = domainNameToIdMap[domainName] || null;
      return { ...skill, domain_id: domainId };
    });

  const noneSkill = skillsWithDomainId?.find((skill) => skill.name === "None");
  const noneDifficulty = difficultyLevel?.find((d) => d.label === "None");

  const handleMapperSave = (mapperQuestions) => {
    const othersBook = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.find((book) => book?.name?.toLowerCase() === "others");

    const othersChapter = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.flatMap((book) => book.chapterData || [])
      ?.find((chapter) => chapter?.chapterName?.toLowerCase() === "others");

    setQuestions((prev) => {
      const updated = [...prev];

      mapperQuestions.forEach((mq) => {
        const base = getBaseQuestionTemplate();
        const selectedType = types.find((t) => t.id === mq.type_id);

        let question = {
          ...base,
          title: mq.title,
          correct_score: mq.correct_score,
          skill_id: noneSkill?.id ?? null,
          domain_id: noneSkill?.domain_id ?? null,
          difficulty_level: noneDifficulty?.id ?? null,
          book_id: othersBook?.id ?? null,
          chapter_id: othersChapter?.id ?? null,
          type_id: mq.type_id,
          question_type: String(selectedType?.is_manually_graded),
          attachments: Array.isArray(mq.attachments)
            ? mq.attachments.map((att) =>
                typeof att === "string" ? att : att.url,
              )
            : [],
        };

        if (selectedType?.is_manually_graded === false) {
          question.options = Array.from(
            { length: mq.mcqOptionsCount },
            (_, i) => ({
              key: String.fromCharCode(65 + i),
              value: `Option ${String.fromCharCode(65 + i)}`,
            }),
          );

          question.correct_answers = [
            {
              option_key: mq.correct_answer ?? null,
              value:
                mq.correct_answer != null
                  ? `Option ${mq.correct_answer}`
                  : null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];
          delete question.subjective_evaluation;
        } else {
          question.options = [];
          question.correct_answers = [
            {
              value: null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];

          if (hasDescriptiveAutoAssessmentFlag && isAutoEvalMode) {
            question.subjective_evaluation = {
              enabled: false,
              expectedAnswer: "",
              rubric: [],
            };
          }
        }

        updated.push(question);
      });

      return updated;
    });
  };

  const isAdaptiveCase =
    selectedBox === "adaptive" ||
    selectedBox?.adaptive ||
    selectedBox?.isAdaptive;

  const getColClass = () => {
    if (isAdaptiveCase) return "col-md-6";
    if (componentType === ComponentType.QUESTION_BANK) return "col-md-3";
    return "col-md-4";
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (!value) {
      setActiveQuestion(null);
      return;
    }
    const questionNumber = parseInt(value);
    if (!isNaN(questionNumber)) {
      const index = questionNumber - 1;
      if (questionRefs.current[index]) {
        scrollToQuestion(index);
      }
      return;
    }
    const lowerValue = value.toLowerCase();
    const foundIndex = questions.findIndex((q) =>
      q?.title?.toLowerCase().includes(lowerValue),
    );
    if (foundIndex !== -1) {
      scrollToQuestion(foundIndex);
    }
  };

  const scrollToQuestion = (index) => {
    const element = questionRefs.current[index];
    const container = scrollContainerRef.current;
    if (!element || !container) return;
    const HEADER_OFFSET = 120;
    const elementTop = element.offsetTop;
    const scrollPosition = elementTop - HEADER_OFFSET;
    container.scrollTo({ top: scrollPosition, behavior: "smooth" });
    setActiveQuestion(index);
  };

  return (
    <div className="row orange-scrollBar">
      <div className="col-12 ">
        <div
          className="w-100 fixed top-0 mt-1 justify-content-evenly d-flex align-items-center gap-1 border p-3"
          style={{
            background: "#fafafa",
            cursor: "pointer",
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          {componentType !== ComponentType.QUESTION_BANK && (
            <div className="d-flex align-items-center gap-4  rounded-4 ">
              <div
                className="d-flex align-items-center gap-4 "
                style={{ cursor: "pointer" }}
                onClick={() => setClickFromCreate(2)}
              >
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: "#FFF1E6",
                    color: "#F28C28",
                    fontSize: "20px",
                    fontWeight: "600",
                    flexShrink: 0,
                  }}
                >
                  &lt;
                </div>

                <div
                  className="d-flex flex-column gap-2"
                  style={{ maxWidth: "200px", minWidth: "200px" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span
                      style={{
                        minWidth: "20px",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#F28C28",
                      }}
                    >
                      Title :
                    </span>
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        color: "#1f2937",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={name}
                    >
                      {name}
                    </span>
                  </div>

                  {componentType !== ComponentType.QUESTION_BANK &&
                    maxMarks > 0 && (
                      <Tooltip
                        title={
                          marksStatus === "match"
                            ? "Perfect! Total marks match the allotted marks"
                            : marksStatus === "exceeded"
                              ? `Exceeded by ${marksDiff} mark(s). Please reduce.`
                              : `${Math.abs(marksDiff)} mark(s) remaining. Please add more.`
                        }
                        arrow
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "8px 14px",
                            borderRadius: "10px",
                            backgroundColor:
                              marksStatus === "match"
                                ? "#dcfce7"
                                : marksStatus === "exceeded"
                                  ? "#fdecea"
                                  : "#fef3c7",
                            border: `1.5px solid ${
                              marksStatus === "match"
                                ? "#86efac"
                                : marksStatus === "exceeded"
                                  ? "#f5c6c2"
                                  : "#fcd34d"
                            }`,
                            cursor: "default",
                            flexShrink: 0,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              color:
                                marksStatus === "match"
                                  ? "#166534"
                                  : marksStatus === "exceeded"
                                    ? "#b91c1c"
                                    : "#92400e",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {marksStatus === "match" ? "✓ " : "⚠ "}
                            Marks: {totalMarks} / {maxMarks}
                          </span>
                          {marksStatus !== "match" && (
                            <span
                              style={{
                                fontSize: "11px",
                                fontWeight: 700,
                                padding: "2px 6px",
                                borderRadius: "6px",
                                backgroundColor:
                                  marksStatus === "exceeded"
                                    ? "#fecaca"
                                    : "#fde68a",
                                color:
                                  marksStatus === "exceeded"
                                    ? "#7f1d1d"
                                    : "#78350f",
                              }}
                            >
                              {marksStatus === "exceeded"
                                ? `+${marksDiff}`
                                : `${marksDiff}`}
                            </span>
                          )}
                        </div>
                      </Tooltip>
                    )}
                </div>
              </div>
            </div>
          )}

          <div className=" row g-3">
            <div className={getColClass()}>
              <LibraryButton
                title="School"
                subtitle="Library"
                img="/images/Picture1.png"
                onClick={() => {
                  setClick1(true);
                  setSourceLibrary(SourceLibrary.FROM_SCHOOL_LIBRARY);
                }}
              />
            </div>

            <div className={getColClass()}>
              <LibraryButton
                title="B4S"
                subtitle="Library"
                img="/images/Picture2.png"
                onClick={() => {
                  setClick1(true);
                  setSourceLibrary(SourceLibrary.FROM_B4S_LIBRARY);
                }}
              />
            </div>
            {componentType === ComponentType.QUESTION_BANK &&
              hasFeature("AI_QUERY") && (
                <div className={getColClass()}>
                  <LibraryButton
                    title="AI"
                    subtitle="Generator"
                    img="/images/add button.svg"
                    onClick={() => setOpenQuestionBox(true)}
                  />
                </div>
              )}

            {!isAdaptiveCase && (
              <div className={getColClass()}>
                <LibraryButton
                  title="Question"
                  subtitle="File"
                  img="/images/fileIconDocument.svg-removebg-preview.png"
                  onClick={() => setNewQuestionPaperMaper(true)}
                />
              </div>
            )}
          </div>

          <button
            disabled={
              !questions ||
              questions.length === 0 ||
              (maxMarks > 0 && isMarksMismatch)
            }
            onClick={() => setOpen(true)}
            className="rounded-3 poppins-semibold d-flex flex-column align-items-center justify-content-center px-3"
            style={{
              height: 44,
              backgroundColor: "#F28C28",
              color: "#ffffff",
              border: "none",
              lineHeight: 1.1,
              opacity:
                !questions ||
                questions.length === 0 ||
                (maxMarks > 0 && isMarksMismatch)
                  ? 0.6
                  : 1,
              cursor:
                !questions ||
                questions.length === 0 ||
                (maxMarks > 0 && isMarksMismatch)
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            <span style={{ fontSize: 14 }}>Review &</span>
            <span style={{ fontSize: 12, fontWeight: 500 }}>Finish</span>
          </button>
        </div>

        <div className="search-container">
          <input
            type="search"
            placeholder="Search by Question No. or Title"
            className="search-input"
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>

        <div
          ref={scrollContainerRef}
          className="orange-scrollBar"
          style={{
            height:
              componentType === ComponentType.QUESTION_BANK
                ? QuestionBankComponentHeight
                : homeWorkComponentHeight,
            overflowY: "auto",
            paddingBottom: "80px",
          }}
        >
          {questions &&
            questions?.length > 0 &&
            questions?.map((question, index) => (
              <div
                key={index}
                ref={(el) => (questionRefs.current[index] = el)}
                className="mb-1 question-item"
              >
                <DefaultQuestion
                  key={index}
                  nextQuestion={index}
                  selectedBox="auto-evaluate" // 👈 Hardcoded as per requirement
                  question={question}
                  setQuestions={setQuestions}
                  assessmentDetails={assessmentDetails}
                  componentType={componentType}
                  qArr={questions}
                  showErrorInputField={showErrorInputField}
                  setShowErrorInputField={setShowErrorInputField}
                  getErrorMsg={getErrorMsg}
                  isChecked={isChecked}
                  isActive={activeQuestion === index}
                  chapter={chapters}
                  questionType={questionType}
                  hasDescriptiveAutoAssessment={true} // 👈 Hardcoded as per requirement
                  onToggle={() =>
                    setActiveQuestion(activeQuestion === index ? null : index)
                  }
                />
              </div>
            ))}

          <div className="d-flex align-items-center justify-content-center mt-3">
            <div
              className="d-flex flex-column gap-2 px-4 py-3 rounded-4"
              style={{
                border: "2px solid #F28C28",
                background: "#FFF7ED",
                width: "fit-content",
                minWidth: "260px",
              }}
            >
              {questions && questions.length > 0 && (
                <>
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <input
                      type="checkbox"
                      checked={copyPrevSettings}
                      onChange={(e) => setCopyPrevSettings(e.target.checked)}
                      style={{
                        accentColor: "#F28C28",
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                      }}
                    />
                    <span
                      className="poppins-semibold"
                      title="Copies book, chapter, skill, difficulty, question type & marks from the previous question"
                      style={{ color: "#8D4B28", fontSize: "14px" }}
                    >
                      Copy Previous settings
                    </span>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      height: "1px",
                      backgroundColor: "#F28C28",
                      opacity: 0.3,
                    }}
                  />
                </>
              )}

              <button
                id="Add-options-btn"
                type="button"
                onClick={addMoreQuestion}
                className="d-flex align-items-center justify-content-center gap-2 px-3 py-1 rounded-3 poppins-semibold"
                style={{
                  border: "2px solid #8D4B28",
                  color: "#8D4B28",
                  backgroundColor: "#fff",
                  fontSize: "14px",
                }}
              >
                <img src="/images/add button.svg" alt="" />
                Add question
              </button>
            </div>
          </div>
        </div>
      </div>

      {componentType !== ComponentType.QUESTION_BANK && click && (
        <QuestionListAssessment
          questions={questions}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          change={setClick}
          total_marks={findTotalMarks()}
          name={name}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          operationType={OperationType.CREATE}
          redirectStateData={redirectStateData}
          isChecked={isChecked}
          selectedBox={selectedBox}
        />
      )}

      {click1 && (
        <SelectFromLibr
          setOpenQuestionBox={setOpenQuestionBox}
          setClick1={setClick1}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          getquestiondata={getquestiondata}
          sourceQsBank={SourceLibrary.FROM_QS_BANK}
          selectedBox={selectedBox}
        />
      )}

      {openQuestionBox && (
        <AiGenerateQuestions
          setClick1={setClick1}
          setOpenQuestionBox={setOpenQuestionBox}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={SourceLibrary.FROM_AI_LIBRARY}
          componentType={componentType}
          getquestiondata={getquestiondata}
        />
      )}

      {componentType === ComponentType.QUESTION_BANK && click && (
        <PublishPreviewQB
          setPreview={setClick}
          displayQuestions={questions}
          details={assessmentDetails}
          type={"create"}
          selectedBox={selectedBox}
          hasDescriptiveAutoAssessment={hasDescriptiveAutoAssessmentFlag}
        />
      )}

      {isInProgress && (
        <div className="loader_bg">
          <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
        </div>
      )}

      {openPopup && (
        <FailedApiErrorPopup
          setClick={setClick}
          apiViewErrorMsg={apiViewErrorMsg}
          setOpenPopup={setOpenPopup}
        />
      )}

      {isopenPopupDupli && (
        <CheckDuplicatePop
          isSetOpenPopupDupli={isSetOpenPopupDupli}
          viewErrorMsg={viewErrorMsg}
          setClick={setClick}
        />
      )}

      {newQuestionPaperMaper && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{
              background: "rgba(0,0,0,0.3)",
              zIndex: 9998,
            }}
          />
          <QuestionPaperMapper
            onClose={() => setNewQuestionPaperMaper(false)}
            selectedBox={selectedBox}
            componentType={componentType}
            onSaveSubmit={(mapperData) => {
              handleMapperSave(mapperData);
              setNewQuestionPaperMaper(false);
            }}
          />
        </>
      )}

      <RightDrawer open={open} onClose={() => setOpen(false)}>
        <div className=" ">
          <div
            className="border rounded p-3 orange-scrollbar"
            style={{
              borderColor: "#e0e0e0",
              borderRadius: "12px",
              boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
              width: "96%",
            }}
          >
            <div className="d-flex align-items-center justify-content-between mb-2 poppins-semibold">
              <div>
                <span style={{ color: "#8D4B28" }}>Subject :</span>{" "}
                <span
                  style={{ fontWeight: "bold", color: "#000" }}
                  title={subject_id?.name}
                >
                  {shortenParagraph(subject_id?.name, 30)}
                </span>
              </div>
              <div
                className="d-flex flex-column align-items-end"
                style={{ gap: 4 }}
              >
                <div>
                  <span style={{ color: "#8D4B28" }}>Total Marks :</span>{" "}
                  <span
                    style={{
                      fontWeight: "bold",
                      color:
                        marksStatus === "match"
                          ? "#16a34a"
                          : marksStatus === "exceeded"
                            ? "#b91c1c"
                            : "#d97706",
                    }}
                  >
                    {totalMarks}
                    {maxMarks > 0 ? ` / ${maxMarks}` : ""}
                  </span>
                </div>
                {maxMarks > 0 && marksStatus !== "match" && (
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: marksStatus === "exceeded" ? "#b91c1c" : "#d97706",
                    }}
                  >
                    {marksStatus === "exceeded"
                      ? `Exceeded by ${marksDiff} mark(s)`
                      : `${Math.abs(marksDiff)} mark(s) remaining`}
                  </span>
                )}
              </div>
            </div>
            <div className="poppins-semibold d-flex align-items-center justify-content-center gap-1">
              <span style={{ color: "#8D4B28" }}>Total Questions :</span>{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {questions?.length}
              </span>
            </div>
          </div>

          <div className="needfulinfo w-100 d-flex flex-column align-item-start p-2 ">
            <div className="skills d-flex align-item-center justify-content-center border border-2 rounded-3 p-2">
              <div className="needfulimg" style={{ width: "60%" }}>
                <img
                  src="/images/needfulimg.png"
                  alt="needfulimg"
                  style={{ width: "100%", marginRight: "12px" }}
                ></img>
              </div>
              <div className="textpart" style={{ width: "40%" }}>
                <h5 className="needful_heading">Skills</h5>
                {questionScoreCounter.skills?.map((curr, index) => {
                  return (
                    <div className="sktext d-flex justify-content-between">
                      {" "}
                      <span>{curr.label + " : "}</span>{" "}
                      <span className="ms-3">{curr.value}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className=" w-100">
              <div
                className="w-100 my-2 difficulty_level border border-2 rounded-3"
                style={{ padding: "6px 15px" }}
              >
                <h5
                  className="d-flex justify-content-center align-items-center gap-2 poppins-semibold"
                  style={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#1f2937",
                    letterSpacing: "0.4px",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                  Difficulty Level
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                </h5>
                <ProgressBar
                  progressItemsData={questionScoreCounter.difficultyLevel}
                />
              </div>
              <div
                className="w-100 ques_type border border-2 rounded-3"
                style={{ padding: "6px 15px" }}
              >
                <h5
                  className="d-flex justify-content-center align-items-center gap-2 poppins-semibold"
                  style={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#1f2937",
                    letterSpacing: "0.4px",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                  Question Type
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                </h5>
                <ProgressBar
                  progressItemsData={questionScoreCounter.questionType}
                />
              </div>
            </div>
          </div>

          <div className=" me-2 d-grid gap-2 d-md-flex justify-content-center align-items-center ">
            {componentType !== ComponentType.QUESTION_BANK && (
              <button
                onClick={() => {
                  if (maxMarks > 0 && isMarksMismatch) {
                    setOpen(false);
                    toast.error(
                      marksStatus === "exceeded"
                        ? `Total marks exceeded by ${marksDiff}. Please reduce.`
                        : `${Math.abs(marksDiff)} mark(s) remaining. Please add more.`,
                    );
                    return;
                  }
                  if (checkAllDataField()) {
                    setOpen(false);
                  }
                  const hasDuplicate = findDuplicateQuestions();
                  if (hasDuplicate) {
                    setOpen(false);
                    return;
                  }
                  setOpen(false);
                  handleCreateAssessment();
                }}
                disabled={!questions || questions.length === 0}
                style={{
                  border: "3px solid #8D4B28",
                  color: "#8D4B28",
                  backgroundColor: "white",
                }}
                className="rounded-3 px-3 py-1 d-flex align-items-center justify-content-center poppins-semibold"
              >
                Save as Draft
              </button>
            )}

            <button
              className="btn next_button"
              disabled={!questions || questions.length === 0}
              onClick={() => {
                if (maxMarks > 0 && isMarksMismatch) {
                  setOpen(false);
                  toast.error(
                    marksStatus === "exceeded"
                      ? `Total marks exceeded by ${marksDiff}. Please reduce.`
                      : `${Math.abs(marksDiff)} mark(s) remaining. Please add more.`,
                  );
                  return;
                }
                const isCheckAllValid = checkAllDataField();
                findDuplicateQuestions();
                handleAdaptiveQuesType();
                if (isCheckAllValid || hidePopupCheck) {
                  setClick(false);
                  setOpen(false);
                } else {
                  setClick(true);
                  setOpen(false);
                }
              }}
            >
              Next
            </button>
          </div>
        </div>
      </RightDrawer>

      {showProcessingDialog && (
        <Dialog open={true} maxWidth="xs" fullWidth>
          <DialogContent sx={{ textAlign: "center", py: 4 }}>
            <Box sx={{ mb: 2 }}>
              <div className="spinner-border text-primary" />
            </Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Saving as Draft...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please wait ⏳
              <br />
              This may take a 1-2 minutes due to large number of questions.
            </Typography>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default CreateQuestion;
